"use client";
import { jsxs as x, jsx as i } from "react/jsx-runtime";
import n from "../../common/components/input-checkbox/InputCheckbox.js";
import h from "../../common/components/label/Label.js";
import b from "@emotion/styled";
import { useFeId as k } from "../../hooks/useFeId.js";
import { SPACINGS as C } from "../../tokens/spacings/Spacings.js";
import { forwardRef as u } from "react";
const a = u(
  ({
    feLabel: c,
    className: s,
    disabled: o,
    feHideLabel: l = !1,
    feRequiredText: p,
    feSeverity: r,
    feSize: e,
    id: t = k(),
    required: m,
    ...f
  }, d) => /* @__PURE__ */ x(y, { className: s, "data-comp": "checkbox", children: [
    /* @__PURE__ */ i(
      n,
      {
        ...f,
        "aria-invalid": r === "error" ? !0 : void 0,
        disabled: o,
        feSeverity: r,
        feSize: e,
        id: t,
        required: m,
        ref: d
      }
    ),
    /* @__PURE__ */ i(
      h,
      {
        feDisabled: o,
        feHideLabel: l,
        feRequired: m,
        feRequiredText: p,
        feSize: e,
        htmlFor: t,
        children: c
      }
    )
  ] })
);
a.displayName = "Checkbox";
const $ = a, y = b.div`
	align-items: center;
	display: flex;
	gap: ${C.xs};
`;
export {
  $ as default
};
